import React, { useState, useRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Typography, Box, Card, CardMedia, CardActionArea, CardContent, ButtonBase, Menu, MenuItem, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { css } from '@emotion/css';
import { ROUTE_MARKETPLACE } from 'constants/routes';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { kindsOfSports } from 'constants/filters';
import DisplayOn from 'shared/components/DisplayOn';
import Heading from '../Heading';
import { useStyles } from './styles';

const Sports = (props: any) => {
	const { classes } = useStyles();
	const theme = useTheme();

	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const refAnchor = useRef(null);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(refAnchor.current);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const mainSports = [
		{
			name: 'Football',
			image: 'https://prod-blocksport-nft-data.s3.eu-central-1.amazonaws.com/assets/kindsofsports/footbal.png',
			href: `${ROUTE_MARKETPLACE}?categories=football`,
		},
		{
			name: 'Rugby',
			image: 'https://prod-blocksport-nft-data.s3.eu-central-1.amazonaws.com/assets/kindsofsports/rugby.png',
			href: `${ROUTE_MARKETPLACE}?categories=rugby`,
		},
		{
			name: 'Basketball',
			image: 'https://prod-blocksport-nft-data.s3.eu-central-1.amazonaws.com/assets/kindsofsports/volleyball.png',
			href: `${ROUTE_MARKETPLACE}?categories=basketball`,
		},
		{
			name: 'Esport',
			image: 'https://prod-blocksport-nft-data.s3.eu-central-1.amazonaws.com/assets/kindsofsports/esport.png',
			href: `${ROUTE_MARKETPLACE}?categories=esports`,
		},
	];

	const MoreBox = () => (
		<Box className={classes.moreBox}>
			<ButtonBase onClick={handleClick}>
				<Typography variant="subtitle1" className={classes.showMore}>
					Show All
				</Typography>
				<KeyboardArrowDownIcon />
			</ButtonBase>
			<Menu
				id="basic-menu"
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				onClose={handleClose}
				onClick={handleClose}
				MenuListProps={{
					'aria-labelledby': 'basic-button',
				}}
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				className={classes.menu}
				hideBackdrop
				keepMounted
			>
				{kindsOfSports.map((item: string, idx: number) => (
					<MenuItem key={idx} component={RouterLink} to={`${ROUTE_MARKETPLACE}?categories=${item}`}>
						{item}
					</MenuItem>
				))}
			</Menu>
		</Box>
	);

	return (
		<div className={classes.root}>
			<Box display="flex" alignItems="center" justifyContent="space-between">
				<Heading label="Trending kinds of sport" className={css({ display: 'flex', justifyContent: 'space-between' })}>
					<DisplayOn media={theme.breakpoints.up('lg')}>
						<MoreBox />
					</DisplayOn>
				</Heading>
			</Box>
			<Box mt={{ sx: 2, lg: 3 }}>
				<Grid container spacing={4} ref={refAnchor}>
					{mainSports.map((item: any, idx: number) => (
						<Grid item key={idx} xs={12} lg={3}>
							<Card sx={{ width: '100%', height: 120 }}>
								<CardActionArea component={RouterLink} to={item.href} className={classes.action}>
									<CardContent className={classes.label}>
										<Typography variant="h2">{item.name}</Typography>
									</CardContent>
									<CardMedia component="img" height="120" image={item.image} alt={item.name} className={classes.media} />
								</CardActionArea>
							</Card>
						</Grid>
					))}
				</Grid>
				<DisplayOn media={theme.breakpoints.between('xs', 'lg')}>
					<Box mt={4} sx={{ textAlign: 'center' }}>
						<MoreBox />
					</Box>
				</DisplayOn>
			</Box>
		</div>
	);
};

export default Sports;
